import { render } from "./AddProjectMemberModal.vue?vue&type=template&id=8d386066&scoped=true"
import script from "./AddProjectMemberModal.vue?vue&type=script&lang=js"
export * from "./AddProjectMemberModal.vue?vue&type=script&lang=js"

import "./AddProjectMemberModal.vue?vue&type=style&index=0&id=8d386066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d386066"]])

export default __exports__